import { useContext } from "react";
import {
  Flex,
  Box,
  Image,
  Text,
  Center,
  Link,
  Container,
} from "@chakra-ui/react";

import { PageContext } from "mlp-sdk";

import { LP_DOCS_NETWORKS_CLICK } from "mlp-sdk/constants/firebase";

import { trackEvent } from "mlp-sdk/utils/firebase";

const Networks = () => {
  const { page } = useContext(PageContext);
  const { networks } = page?.data?.pageData || {};

  return (
    <Center>
      <Container
        pt={{ base: "64px", lg: "80px" }}
        pb={{ base: "64px", lg: "160px" }}
        textAlign="center"
      >
        <Text textStyle={{ base: "h2", lg: "h1" }}>Supported networks</Text>

        <Text
          mt={2}
          fontWeight="500"
          fontSize="14px"
          lineHeight="22px"
          color="textSecondary"
        >
          Documentation for Stader supported networks
        </Text>

        <Center>
          <Flex
            maxW="786px"
            gap={{ base: "1rem", lg: "1.5rem" }}
            mt="64px"
            mb={{ base: 0, lg: "80px" }}
            px={{ base: "1rem", lg: 0 }}
            justify="center"
            flexWrap="wrap"
            textAlign="left"
          >
            {networks &&
              networks.map((network: any) => (
                <Link
                  key={network.title}
                  href={network.link}
                  rel="canonical"
                  isExternal
                  onClick={() => {
                    trackEvent(LP_DOCS_NETWORKS_CLICK, {
                      title: network.title,
                    });
                  }}
                >
                  <Box
                    p={{ base: "16px 24px;", lg: "40px 12px" }}
                    bg="#E6F8EF"
                    borderRadius="1rem"
                    minHeight={{ base: "102px", lg: "176px" }}
                    w={{ base: "328px", lg: "381px" }}
                    color="textPrimary"
                    _hover={{
                      bg: "#07C166",
                      color: "white",
                    }}
                  >
                    <Flex alignItems="center" gap="1rem">
                      <Image
                        src={network.img_key}
                        boxSize={{ base: "48px", lg: "88px" }}
                        alt={`${network.title}-icon`}
                      />
                      <Flex
                        gap={{ base: 0, lg: "8px" }}
                        p="0 10px"
                        alignItems="flex-start"
                        flexDir="column"
                      >
                        <Text
                          textStyle={{ base: "p16", lg: "h3" }}
                          fontWeight={{ base: "500", lg: "700" }}
                          lineHeight={{ base: "20px", lg: "28px" }}
                          // color="textPrimary"
                        >
                          {network.title}
                        </Text>
                        <Text
                          textStyle={{ base: "p12", lg: "p14" }}
                          // color="textSecondary"
                          lineHeight={{ base: "16px", lg: "20px" }}
                        >
                          {network.description}
                        </Text>
                      </Flex>
                    </Flex>
                  </Box>
                </Link>
              ))}
          </Flex>
        </Center>
      </Container>
    </Center>
  );
};

export default Networks;
